import { AutogenModelQuikqAsset, AutogenRowQuikqAsset } from "./autogen/AutogenModelQuikqAsset";

export class ModelQuikqAsset extends AutogenModelQuikqAsset<RowQuikqAsset> {
	constructor() {
		super(RowQuikqAsset);
	}
}

export class RowQuikqAsset extends AutogenRowQuikqAsset {
}